import { base_colorAlert, grey50, grey700, white100 } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  background-color: ${white100};
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  border-radius: 10px;

  .ContentCard {
    box-shadow: none;
  }

  &.has-top-alert-panel {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  &.darkened {
    background-color: rgba(0, 0, 0, 0.2);
    color: ${grey700};

    &:hover {
      cursor: not-allowed;
    }
  }

  // Overrides styling for the AlertPanel component inside
  // of this component
  .AlertPanel.warning {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    .font-bold {
      ${font_md};
    }

    .font-regular {
      ${font_md}
    }
  }

  .VirtualCardCapabilitiesPanel-bottom {
    padding: ${spacing(4)} ${spacing(10)} ${spacing(4)};
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    background-color: ${grey50};

    .connect-text,
    .disconnect-text {
      ${font_md}
    }

    .disconnect-text {
      color: ${base_colorAlert};
    }

    .linktext-content {
      display: inline-block;
    }
  }
`
